import React, { useEffect, useState } from "react";
import { useModal } from "../../../components/ContextApi/modal/modalContext";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { createPublicCharacter } from "../../../store/character/actions";

const Step10 = ({
  imageGenerated,
  setImageGenerated,
  kinks,
  setKinks,
  relationship,
  occupation,
  chatStyle,
  sexOrientation,
  traits,
  personality,
  eye,
  hairColor,
  hairStyle,
  butt,
  boobs,
  physique,
  height,
  ethnicBackground,
  age,
  art,
  gender,
  step,
  setStep,
  appearanceList,
  appearanceLoading,
}) => {
  const { openModal, closeModal } = useModal();

  // const authState = useSelector((state) => state.Auth);
  // const authenticate = authState.isAuthenticated;
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.Auth);
  const userId = user?.user?._id;

  const [socket, setSocket] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  const [showAll, setShowAll] = React.useState(false);

  const allItems = appearanceList?.kinks?.[0]?.options || [];
  const INITIAL_LIMIT = 12;
  const hasMore = allItems.length > INITIAL_LIMIT;
  const visibleItems = showAll ? allItems : allItems.slice(0, INITIAL_LIMIT);

  const aiObject = {
    gender: gender,
    art: art,
    age: age,
    ethnicBackground: ethnicBackground,
    height: height,
    physique: physique,
    boobs: boobs,
    butt: butt,
    hairStyle: hairStyle,
    hairColor: hairColor,
    eye: eye,
    personality: personality,
    traits: traits,
    sexOrientation: sexOrientation,
    chatStyle: chatStyle,
    occupation: occupation,
    relationship: relationship,
    kinks: kinks,
    type: "personal",
    isRequestedPublic: "personal",
  };

  // ✅ STEP 1: Initialize socket when component mounts
  useEffect(() => {
    if (userId) {
      console.log("🔌 Initializing socket for user:", userId);
      const socketInstance = initializeSocket(userId);
      setSocket(socketInstance);

      // Verify socket connection
      if (socketInstance) {
        console.log("✅ Socket instance created:", socketInstance.id);
      }
    }
  }, [userId]);

  // ✅ STEP 2: Set up socket listener IMMEDIATELY when socket is available

  useEffect(() => {
    if (!socket) {
      console.warn("⚠️ Socket not available yet");
      return;
    }

    console.log(
      "👂 Setting up image_Notification listener on socket:",
      socket.id,
    );

    // Handler function
    const handleImageNotification = (payload) => {
      console.log("📨 Received socket event:", payload);
      console.log("Event type:", payload.type);
      console.log("Event status:", payload.status);
      console.log("Event data:", payload.data);

      if (payload.type === "Character") {
        if (payload.status === "processing") {
          console.log("⏳ Character is being processed...");
          toast.info("Generating your character...");
        } else if (payload.status === "success") {
          console.log("✅ Character generation SUCCESS!");
          console.log("Character data:", payload.data);
          console.log("Image URL:", payload.data?.image);

          // Close loading modal
          closeModal();

          // Update state with generated character
          setImageGenerated(payload.data);

          // Move to final step
          setStep(11);

          // Reset creating state
          setIsCreating(false);

          toast.success("Character generated successfully!");
        } else if (payload.status === "failed") {
          console.error("❌ Character generation FAILED");
          console.error("Error:", payload.message);

          closeModal();
          setIsCreating(false);
          toast.error(payload.message || "Failed! Please try again!");
        }
      }
    };

    // ⭐ CHANGED: Listen to "image_Notification" instead of "image_generated"
    socket.on("image_Notification", handleImageNotification);

    console.log("✅ Listener attached successfully");

    // Cleanup on unmount
    return () => {
      console.log("🧹 Cleaning up socket listener");
      socket.off("image_Notification", handleImageNotification);
    };
  }, [socket, closeModal, setImageGenerated, setStep]);

  // ✅ STEP 3: Handle create AI button click
  const handleCreateAi = () => {
    if (isCreating) {
      console.warn("⚠️ Already creating a character, please wait...");
      toast.warning("Character creation already in progress");
      return;
    }

    console.log("🚀 Starting character creation...");
    console.log("Socket ID:", socket?.id);
    console.log("User ID:", userId);
    console.log("AI Object:", aiObject);

    // Set creating state
    setIsCreating(true);

    // Open loading modal
    openModal("generate-loading-pop");

    // Callback from API
    const callBack = (err, response) => {
      if (err) {
        console.error("❌ API Error:", err);
        closeModal();
        setIsCreating(false);
        toast.error(err.message || "Failed to create character");
        return;
      }

      console.log("✅ API Response received:", response);
      console.log("Character ID:", response?.data?.character?._id);

      // Don't close modal yet - wait for socket event
      // toast.info("Character created! Generating image...");

      // Note: Modal will close when socket event arrives with status="success"
    };

    // Dispatch API call
    dispatch(
      createPublicCharacter({
        data: aiObject,
        callBack,
      }),
    );
  };

  const canProceed = kinks;

  return (
    <>
      <div className="mx-auto flex flex-col gap-4">
        {/* <div className="text-center">
          <h4 className="m-0 text-[20px]">CREATE YOUR AI CHARACTER</h4>
          <p className="m-0 py-2 font-normal">Take Control of your Character</p>
        </div> */}
        <div className="">
          <div className="mx-auto mt-5 rounded-[12px] max-w-[870px]">
            <div className="top pb-3 text-center">
              <h6 className="m-0 py-2 font-semibold text-[20px]">
                {appearanceList?.kinks?.[0]?.name}
              </h6>
            </div>
            <div className="py-3 mb-5">
              <form action="" className="max-w-[322px] mx-auto relative">
                <span className="absolute transform left-3 top-[50%] translate-y-[-50%]">
                  {searchIcn}
                </span>
                <input
                  type="text"
                  placeholder="Search"
                  className="w-full placeholder:text-[#E7E6F8] font-normal pl-[45px] border border-[#272727] bg-[#fff] h-[42px] rounded-[12px]"
                />
              </form>
            </div>
            <div className="">
              <ul className="list-none pl-0 mb-0 grid grid-cols-12 gap-3 flex-wrap">
                {visibleItems.map((item, key) => {
                  const isCustom = item.name === "Custom +";
                  return (
                    <li
                      key={key}
                      className="relative lg:col-span-2 md:col-span-3 sm:col-span-4 col-span-6"
                    >
                      <input
                        type="radio"
                        value={item.name}
                        checked={kinks === item.name}
                        onChange={(e) => {
                          if (isCustom) {
                            openModal("custom-add-label-pop", {
                              label: "Add Kinks",
                              field: "Kinks",
                            });
                          } else {
                            setKinks(e.target.value);
                          }
                        }}
                        name="kinks"
                        className="absolute peer top-0 left-0 w-full h-full z-[9] cursor-pointer opacity-0"
                      />
                      <div className="h-[41px] peer-checked:border-[#e343a5] text-[#838383] border border-[#ddd] flex items-center justify-center rounded-[8px] px-3 min-w-[96px] peer-checked:bg-[#e343a5] peer-checked:text-white font-medium text-center leading-tight">
                        {item.title.title}
                      </div>
                    </li>
                  );
                })}
              </ul>

              {hasMore && (
                <div className="mt-6 text-center">
                  <button
                    className="inline-block p-0 border-0 bg-transparent text-[#E443A6]"
                    onClick={() => setShowAll((prev) => !prev)}
                  >
                    {showAll ? "- Show less" : "+ Show more"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="mt-[80px] mx-auto max-w-[516px] w-full">
          <button
            disabled={!canProceed}
            onClick={() => canProceed && setStep(11)}
            className={`${!canProceed && "opacity-50 cursor-not-allowed"}  flex items-center justify-center gap-2 h-[45px] bg-[#E443A6] w-full px-3 rounded-[10px] text-white font-medium`}
          >
            Next {rightIcn}
          </button>
        </div>
      </div>
    </>
  );
};

export default Step10;

const searchIcn = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
      fill="#E3E3E3"
    />
  </svg>
);

const rightIcn = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 10.0013C17.5 10.4613 17.1267 10.8346 16.6667 10.8346H3.33333C2.87333 10.8346 2.5 10.4613 2.5 10.0013C2.5 9.5413 2.87333 9.16797 3.33333 9.16797H16.6667C17.1267 9.16797 17.5 9.5413 17.5 10.0013Z"
      fill="white"
    />
    <path
      d="M15.8115 10.0002C15.734 9.87103 15.5707 9.63936 15.3923 9.4377C15.0382 9.03603 14.549 8.5777 14.0382 8.13436C13.5323 7.6952 13.0232 7.28686 12.6398 6.98686C12.4482 6.8377 12.1182 6.58853 12.0073 6.50436C11.6365 6.23186 11.5573 5.7102 11.8307 5.33936C12.1032 4.96853 12.6248 4.88936 12.9957 5.1627L12.999 5.1652C13.119 5.25603 13.4682 5.51936 13.6648 5.67353C14.0632 5.98353 14.5957 6.41103 15.1315 6.87603C15.6623 7.33686 16.2148 7.85186 16.6415 8.33436C16.854 8.57436 17.0532 8.82686 17.2032 9.07603C17.339 9.30186 17.5015 9.63103 17.5015 10.0002C17.5015 10.3694 17.339 10.6985 17.2032 10.9244C17.0532 11.1735 16.854 11.426 16.6415 11.666C16.2148 12.1485 15.6623 12.6635 15.1315 13.1244C14.5957 13.5894 14.0632 14.0169 13.6648 14.3269C13.4682 14.481 13.119 14.7444 12.999 14.8352L12.9957 14.8377C12.6248 15.111 12.1032 15.0319 11.8307 14.661C11.5573 14.2902 11.6365 13.7685 12.0073 13.496C12.1182 13.4119 12.4482 13.1627 12.6398 13.0135C13.0232 12.7135 13.5323 12.3052 14.0382 11.866C14.549 11.4227 15.0382 10.9644 15.3923 10.5627C15.5707 10.361 15.734 10.1294 15.8115 10.0002Z"
      fill="white"
    />
  </svg>
);

const checkIcn = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.71Z"
      fill="currentColor"
      fillOpacity="1"
    />
  </svg>
);
